// @ts-nocheck
import {Injectable, Injector} from '@angular/core';
import {MenuCategory, MenuItem, MenuItemAttribute, MenuSection} from "../models/FSMenu";
import {FireService} from "./fire.service";
import {AppStateService} from "./app-state.service";
import {BehaviorSubject, combineLatest, interval, Observable, of, ReplaySubject, Subscription, timer} from "rxjs";
import {HackUtils, LangUtils} from "../utils/Utils";
import {debounce, filter, first, flatMap, map, tap} from "rxjs/operators";
import {Translation} from "../models/Translation";
import {VenueConfig} from "../models/FSConfig";
import {Order} from "../models/Order";
import {LinguaService} from './lingua.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  public lang = "sv";
  // The venue's language from cfg.locale.language, as one of our language codes ("sv", "no", ...): the guest's
  // language until they pick one, and what the language push offers to keep
  public venueLang = "sv";
  private venueId?: number;
  private sub1a?: Subscription;
  private sub1b?: Subscription;
  private sub2?: Subscription;
  private menuSub?: Subscription;
  private progressSub?: Subscription;
  private tobeTranslated = [];
  private inTranslationPipe = new Set();
  private config?: VenueConfig;
  public useTranslations: boolean = false;
  private urlLangOverride?: string;

  private translateSubject = new ReplaySubject<number>(1);
  private translationMap = {};
  public translationsReceivedSubject = new ReplaySubject<number>(1);
  private backgroundTranslationInProgress = false;
  private progressUpdateSubject = new ReplaySubject<number>(1);

  // Translation progress tracking
  public isTranslationInProgress: boolean = false;
  private localTextStringIds = new Set<string>();
  private translationProgressSubject = new BehaviorSubject<{inProgress: boolean, percentage: number}>({
    inProgress: false,
    percentage: 0
  });

  public translationAlertText = "Vänligen notera att valet av språk i vår app aktiverar automatisk översättning. Vi strävar alltid efter att ge korrekta översättningar, men vi kan inte garantera att alla texter kommer att vara 100% korrekta. Om du upptäcker några felaktigheter i översättningarna, var snäll och meddela oss så att vi kan åtgärda dem så snart som möjligt. Vi hoppas att du kommer att njuta av att använda vår app i ditt valda språk!";
  public STRING_ACTIVATE1 = "Aktivera biljetten när du skall hämta ut din beställning och visa den till personalen. Tänk på att biljetten har en tidsgräns på 1 min så aktivera den inte för tidigt.";
  public STRING_ACTIVATE2 = "Du aktiverar biljetten genom att dra pilen åt höger.";
  public ALL_IS_PAID1 = "Här kan du betala och dela upp notor för beställningar vid ditt bord.";
  public ALL_IS_PAID_MORE = "Det finns artiklar att betala som andra på bordet har beställt";
  public ALL_IS_PAID2 = "Just nu är allt betalt 👍";
  public SHOW_TICKET = "Visa upp biljetten i samband med att du hämtar ut din beställning. Bon appetit!";
  public WEEK_EMPTY = "Veckans meny innehåller inga artiklar för denna dag";

  // Language push screen string constants (%s = a language name)
  public LANG_PUSH_SELECT_LANGUAGE = "Välj språk";
  public LANG_PUSH_YES_SWITCH = "Ja, byt till %s";
  public LANG_PUSH_NO_KEEP_SWEDISH = "Nej, behåll %s";
  public LANG_PUSH_ORIGINAL_LANGUAGE = "Originalspråket för denna meny är %s";
  public LANG_PUSH_USE_TRANSLATION = "Vill du använda en översatt version?";
  public LANG_PUSH_SELECT_OTHER = "Välj annat språk";

  public langPushScreen = [
    this.LANG_PUSH_SELECT_LANGUAGE,
    this.LANG_PUSH_YES_SWITCH,
    this.LANG_PUSH_NO_KEEP_SWEDISH,
    this.LANG_PUSH_ORIGINAL_LANGUAGE,
    this.LANG_PUSH_USE_TRANSLATION,
    this.LANG_PUSH_SELECT_OTHER
  ]

  validSingleStrings = ["Mat","Dryck","Betala","Notan","Stäng","Lägg till","Ange webbkoden",
    "E-post", "Logga in", "Skicka beställning", "Konfirmera bokning", "Betala och boka", "Totalt", "Språk", "Stängt för beställning", "Just nu kan du inte beställa något här.",
    "Du kan redigera din bokning fram tills du konfirmerar den, öppna den via bokningslänken.", "Bokningen måste konfirmeras senast", "Efter konfirmering kan den inte ändras.",
    "Betala notan", "Händelser", "Mitt konto", "Veckans meny",
    "Anpassa rätten (allergier och innehåll)", "utan", "och", "INNEHÅLLER", "WEBBKOD",
    "Felaktig webbkod", "Byt bord", "Rabattkod", "Passar bra till",
    "Meny", "Fortsätt med", "Rabatt",
    "Bekräfta din plats", "Är du kvar på", "Ja", "Går inte att få utan",
    "Info","Du har inte lagt till något i din beställning ännu. Välj mat och dryck från menyn.", "Fortsätt", "Namn", "Konto skapat", "Logga ut",
    "Koppla Messenger-konto", "Kontotyp", "Om du byter leveranssätt så kommer din beställning att tömmas.", "Avbryt",
    "Gåva", "Ingen", "Dricks", "Välj dricksbelopp",
    "Sparat kort", "Annat kort",
    "Tack för ditt köp!", "Din beställning", "Tack för din beställning.", "Vi kommer strax ut med den.",
    this.STRING_ACTIVATE1, this.STRING_ACTIVATE2, this.ALL_IS_PAID1, this.ALL_IS_PAID2, this.SHOW_TICKET, this.WEEK_EMPTY,
    "Notan är betald. Beställningsnummer", "Kvitto", "Maila kvittokopia", "Maila kvitto", "Miljövänligt kvitto", "Elektroniska kvitton är ett bra miljöval.",
    "Välj alla", "Välj", "kvar", "kvar på notan", "reserverat av andra", "Reserverad av", "Betalad av", "dela", "Dela upp", "Hur många personer skall dela?", "Kassakvitto",
    "Notan är betald", "Dela notan", "Se hela notan", "Slutför",
    "Wow! 😍 😍", "och övrig personal gör allt för att du skall ha en trevlig upplevelse, så stort tack för dricksen!", "Tack för dricksen!", "kommer strax ut med din beställning.",
    "Hoppas att allt var till din belåtenhet.", "Tack!", "Skicka kvittokopia", "Skicka kvitto", "Mån,Tis,Ons,Tor,Fre",
    "Fyll på kort", "Fyll på kort med", "Balans", "Kan användas vid betalning i kassan", "Logga in för att fylla på kort", "Ingår i beställning",
    "Gemensam nota", "Beställningar via personalen", "Beställningar som du delar med andra", "Dina beställningar",
    "Verifiera med telefon", "Skickar kod...", "Verifierar kod...", "Levereras", "Hämtas", "Leveransplats", "Upphämtningsplats", "Upphämtning", "(välj annan tid)", "Kontaktinformation", "Uppgifter",
    "Din förbokning är genomförd", "Visa bokning", "Bokningsnummer",
    "Beställ och betala", "Beställ", "Innan du beställer behöver vi veta var du sitter", "Ange din bordskod. Den består av 5 bokstäver och du hittar den på ditt bord.",
    "Ange bordskod", "Välj Bord", "Min profil", "Rabattkort", "Verifiera dig för att skaffa eller hantera rabattkort", "Saldo saknas", "Saldo", "Fyll på med",
    "Lojalitetsprogram", "Verifiera", "Lägg till befintligt", "Verifiera dig för att skaffa eller hantera lojalitetsprogram", "Skaffa",
    "Kvitton", "Inga kvitton hittills", "Se menyn", "Kalla på servis", "Konto",
    "Ange SMS-koden", "Skicka kod", "Verifiera koden", "Ange mobilnummer",
    "Genom att gå vidare samtycker du till skapandet av en profil där dina köp registreras. Du kan läsa om hur data lagras under \"Mitt konto\" och även ta bort din profil.",
    "Ange ditt mobilnummer, så skickar vi en verifieringskod till dig via SMS.", "Kolla i din telefon efter SMS-koden och ange den här ovan.",
    "Innan du beställer behöver vi veta vem du är", "Verifiera dig", "Ändra", "Uppdatera", "Aktivera", "Samlade poäng",
    "Välj tid och datum","Vänligen välj en upphämtningsplats innan du går vidare.", "OK", "Telefon",
    "Tillbaka till menyn", "... eller byt leveranssätt", "Hur vill du beställa?", "Se veckans meny",
    "Visa tidigare händelser", "Visa äldre händelser", "Övriga anpassningar", "Välj tillval", "Oj, här fanns inga artiklar att visa", "Obligatoriskt tillval för erbjudande",
    "Visa QR-koden för en skanningsstation inne på restaurangen för att få en voucher.", "Något gick fel!", "Klar", "Här nedan är din biljett!", "Här nedan är dina biljetter!",
    "Du kan använda den direkt från telefonen, eller maila den för utskrift.", "Presentkort", "minuter tillagningstid", "Slutsåld", "Köket är stängt", "Välj upphämtningstid",
    "Anpassa", "Betalningen avbruten",
    "Boka bord", "Våra menyer",
    "Välj måltid", "Välj antal personer", "Välj datum", "Välj tid", "Kontaktuppgifter", "Bekräfta", "Bekräftelse",
    "Bordsbokning är inte aktiverad för denna venue", "(%s barn)", "(varav %s barn)", "person", "personer", "Varav barn",
    "Mån,Tis,Ons,Tor,Fre,Lör,Sön", "Inga tillgängliga tider för detta datum",
    "Ditt namn", "Meddelande", "(valfritt)", "Allergier, specialönskemål...", "Granska bokning",
    "Bordsbokning är inte aktiverat", "Ogiltig bokningstyp", "För få gäster", "För många gäster",
    "Tiden är inte längre tillgänglig", "Inga bord tillgängliga för detta sällskap",
    "Antal personer", "Datum", "Tid", "Bekräfta bokning", "Ett fel uppstod. Försök igen.",
    "Bokning bekräftad!", "Bokningsreferens", "Typ", "Antal", "En bekräftelse har skickats till", "Gör en ny bokning",
    "Betygsätt på Google", "Mat & Dryck", "Service", "Atmosfär", "Prisvärdhet", "Skicka in", "Spara och stäng",
    "Betygsätt ditt besök", "Tack för din feedback!", "Tidsfristen för att lämna omdöme har gått ut", "Hur var din upplevelse hos oss?",
    "Betala din nota", "Tack för din betalning!",
    // Bill payment (payment link, pre-bill QR, table bill) and its failure/receipt pages
    "Välj det du skall betala", "(Dela)", "Avmarkera valda", "köpvillkor", "köpvillkoren", "Genom att betala godkänner du", "Försök igen",
    "Betala med annan enhet", "Betala med telefonnummer", "Glömde du att betala för något?", "Se bordsnotan",
    "Något gick snett", "Betalningen gick inte igenom", "Betala på annat sätt", "Pris med rabatt",
    "Betala med faktura", "Betala med samlingsfaktura", "Notan är betald", "Det finns %s kvar på notan",
    "Skicka kvittokopia", "Kvitto ej angivet", "Något gick fel", "Lämna omdöme", "Skicka",
    "Ange e-post", "Ogiltig e-post", "Spara e-post", "Skickar...", "Ange Rabattkod",
    "Oj den hann bli reserverad!", "Gick inte att reservera artikeln", "Gick inte att reservera", "Gick inte att dela",
    "Betalningen avbruten", "Ett fel uppstod", "Ingen användare", "Okänd betalmetod", "Okänt fel"
  ];

  constructor(private fire: FireService, private state: AppStateService, private lingua: LinguaService, private injector: Injector) {
    state.observeAppState().subscribe(appState => {
      this.useTranslations = appState?.cfg?.use_translations === true;
      this.venueLang = LangUtils.venueLanguage(appState?.cfg);
      if (this.useTranslations) {
        const langChanged = appState != null && appState.lang != null && appState.lang !== this.lang;
        const venueChanged = appState != null && appState.venueId != null && appState.venueId !== this.venueId;
        if (langChanged || venueChanged) {
          this.config = appState.cfg;
          this.prepapreTranslation(appState.venueId!, appState.lang!);
        }
      }
    });
    this.translationsReceivedSubject.next(0);
  }

  private prepapreTranslation(venueId: number, lang: string) {
    this.venueId = venueId;
    this.lang = lang;
    if (lang === "sv") {
      return;
    }

    console.log(`Prepare translation to ${lang}, ${venueId}`);
    this.sub1a?.unsubscribe();
    this.sub1b?.unsubscribe();
    this.menuSub?.unsubscribe();
    this.translationMap = {};
    this.inTranslationPipe.clear();

    // Reset translation progress tracking
    this.localTextStringIds.clear();
    this.isTranslationInProgress = true;
    this.translationProgressSubject.next({
      inProgress: true,
      percentage: 0
    });

    // Observe venue specific translations
    this.sub1a = this.fire.observeTranslations(venueId, lang).subscribe(translations => {
      const n = this.addToTranslationMap(translations);
      if (n>0) {
        console.log(`Received ${n} translations for ${lang} (${venueId})`);
        this.translationsReceivedSubject.next(n);
      }

      // Update translation progress
      this.updateTranslationProgress();
    });

    // Observe global translations
    this.sub1b = this.fire.observeTranslations(1, lang).subscribe(translations => {
      const n = this.addToTranslationMap(translations);
      if (n>0) {
        console.log(`Received ${n} translations for ${lang} (${venueId})`);
        this.translationsReceivedSubject.next(n);
      }
    });

    this.sub2?.unsubscribe();
    this.sub2 = this.translateSubject.pipe(debounce(() => timer(500))).subscribe(n => {
      this.executeTranslation();
    });

    // Set up debounced progress updates
    this.progressSub?.unsubscribe();
    this.progressSub = this.progressUpdateSubject.pipe(debounce(() => timer(200))).subscribe(() => {
      this.updateTranslationProgress();
    });

    // Start background menu translation
    this.startBackgroundMenuTranslation(venueId);
  }

  single(s: string, postCase = "normal"): string {
    if (this.lang === "sv") { return s; }
    let r = null;
    if (s != null && this.validSingleStrings.includes(s)) {
      const ts = this.translateString(s, false, true);
      r = ts.text;
    } else {
      //Just try to resolve it, if it's not a valid single
      const strId = HackUtils.simpleBitHashHex(s);
      const translated = this.resolveTranslation(strId);
      if (translated != null) {
        r = translated;
      }
    }
    if (r == null) {
      r = s;
    } else if (r !== s && /[.。]$/.test(r) && !/[.!?:…]$/.test(s.trim())) {
      // Machine translation likes to end a label with a full stop ("Split the bill."); a source without
      // sentence punctuation is a label, not a sentence
      r = r.replace(/[.。]+$/, "");
    }
    if (postCase === "upper") {
      return r.toUpperCase();
    } else if (postCase === "lower") {
      return r.toLowerCase();
    } else if (postCase === "cap" && r.length > 0) {
      return r.charAt(0).toUpperCase() + r.slice(1);
    }
    return r;
  }

  private attributes(attrList: MenuItemAttribute[], dontTranslate: boolean) {
    if (this.lang === "sv") { return {text: null, ok: true}; }
    if (attrList != null) {
      for (const atr of attrList) {
        for (const option of atr.options) {
          const tn = this.translateString(option.value, dontTranslate);
          option.value = tn.text!;
          if (option.contains != null) {
            for (const c of option.contains) {
              const tc = this.translateString(c.name, dontTranslate);
              c.name = tc.text!;
            }
          }
        }
      }
    }
    return {text: null, ok: false};
  }

  items(items: MenuItem[]): MenuItem[] {
    if (this.lang === "sv") { return items; }
    if (items != null) {
      for (const item of items) {
        this.item(item);
      }
    }
    return items;
  }

  private item(item: MenuItem) {
    if (this.lang === "sv") { return }
    if (item.lang !== this.lang) {
      item.lang = "-";
      const tn = this.translateString(item.name, false);
      item.name = tn.text;
      const td = this.translateString(item.desc, false);
      item.desc = td.text;
      const ta = this.attributes(item.attributes, false);
      if (item.contains != null) {
        for (const c of item.contains) {
          this.translateString(c.name, false);
        }
      }
      if (item.adjusts != null) {
        for (const a of item.adjusts) {
          this.translateString(a.name, false);
        }
      }
      if (item.pushes != null) {
        for (const p of item.pushes) {
          this.translateString(p.title, false);
          for (const pg of p.groups) {
            this.translateString(pg.title, false);
          }
        }
      }
      item.lang = tn.ok && td.ok && ta.ok ? this.lang : "-";
    }
  }

  categories(cats: MenuCategory[]) {
    if (this.lang === "sv") { return cats; }
    if (cats != null) {
      for (const cat of cats) {
        //console.log("Translate cat: ", cat);
        if (cat.lang !== this.lang) {
          cat.lang = "-";
          const tn = this.translateString(cat.name, false);
          cat.name = tn.text;
          const td = this.translateString(cat.desc, false);
          cat.desc = td.text;
          cat.lang = tn.ok && td.ok ? this.lang : "-";
        }
      }
    }
    return cats;
  }

  sections(sections: MenuSection[]): MenuSection[] {
    if (this.lang === "sv") { return sections; }
    if (sections != null) {
      for (const section of sections) {
        if (section.lang !== this.lang) {
          section.lang = "-";
          const tn = this.translateString(section.name, false);
          section.name = tn.text;
          const td = this.translateString(section.desc, false);
          section.desc = td.text;
          section.lang = tn.ok && td.ok ? this.lang : "-";
        }
      }
    }
    return sections;
  }

  order(order: Order) {
    if (this.lang === "sv") { return; }
    if (order != null) {
      for (const item of order.items) {
        if (item.customized) {
          const parts = item.customized.split(",");
          console.log("Translate parts: ", parts);
          const translated = [];
          for (const part of parts) {
            const p = part.trim();
            // Check if part starts with a quantity pattern like "5x " or "10x "
            const quantityMatch = p.match(/^(\d+x\s+)/);
            if (quantityMatch) {
              const prefix = quantityMatch[1];
              const textToTranslate = p.substring(prefix.length);
              const tr = this.translateString(textToTranslate, true);
              translated.push(prefix + tr.text);
            } else {
              const tr = this.translateString(p, true);
              translated.push(tr.text);
            }
          }
          console.log("Translated parts: ", translated);
          item.customized = translated.join(", ");
        }
      }
    }
  }

  private translateString(phrase: string, dontTranslate: boolean, globalTranslation = false): {text: string|null, ok: boolean} {
    if (this.lang === "sv") { return {text: phrase, ok: true}; }
    if (phrase == null) {
      return {text: null, ok: true};
    }
    const strId = HackUtils.simpleBitHashHex(phrase);
    const venueId = globalTranslation ? 1 : this.venueId;

    // Track all local text string IDs (both translated and untranslated)
    if (venueId !== 1) {
      this.localTextStringIds.add(strId);
      // Trigger debounced progress update
      this.progressUpdateSubject.next(1);
    }

    const translated = this.resolveTranslation(strId);
    if (translated != null) {
      return {text: translated, ok: true};
    }
    if (!this.inTranslationPipe.has(strId) && !dontTranslate) {
      this.translateSubject.next(1);
      this.tobeTranslated.push({strId, phrase, venueId});
      this.inTranslationPipe.add(strId);
    }
    return {text: phrase, ok: false};
  }

  private resolveTranslation(strId: string) {
    // @ts-ignore
    const t = this.translationMap[strId];
    if (t != null) {
      return t.translation;
    }
    return null;
  }

  private executeTranslation() {
    const filtered = this.filterAlreadyTranslated(this.tobeTranslated);
    this.tobeTranslated = [];
    if (filtered.length > 0) {
      console.log("Execute translations: ", filtered);
      const phrasePairs = filtered.map(p => ({phrase: p.phrase, str_id: p.strId, venue_id: p.venueId}));
      this.lingua.translate(phrasePairs, this.lang).subscribe(res => {
        console.log("res: ", res);
      }, error => {
        console.error("Failed to execute translations...", error);
      });
    }
  }

  private filterAlreadyTranslated(translatePairs: any[]): any[] {
    const filtered = [];
    for (const pair of translatePairs) {
      const translated = this.resolveTranslation(pair.strId);
      if (translated == null) {
        filtered.push(pair);
      }
    }
    return filtered;
  }

  private addToTranslationMap(translations: Translation[]): number {
    console.log("Translations received", translations);
    let receivedNewTranslation = 0;

    for (const t of translations) {
      if (this.translationMap[t.str_id] !== t) {
        this.translationMap[t.str_id] = t;
        receivedNewTranslation += 1;
      }
    }

    return receivedNewTranslation;
  }

  private updateTranslationProgress() {
    const totalLocalTextCount = this.localTextStringIds.size;

    if (totalLocalTextCount === 0) {
      // No local texts to translate
      this.isTranslationInProgress = false;
      this.translationProgressSubject.next({
        inProgress: false,
        percentage: 100
      });
      return;
    }

    // Count how many local text IDs have translations
    let translatedCount = 0;
    for (const strId of this.localTextStringIds) {
      if (this.translationMap[strId]) {
        translatedCount++;
      }
    }

    const percentage = (translatedCount / totalLocalTextCount) * 100;
    const isComplete = percentage >= 95;

    this.isTranslationInProgress = !isComplete;

    this.translationProgressSubject.next({
      inProgress: !isComplete,
      percentage: Math.min(percentage, 100)
    });

    console.log(`Translation progress: ${percentage.toFixed(1)}% (${translatedCount}/${totalLocalTextCount})`);
  }

  public observeAlert(lang: string): Observable<Translation> {
    return this.observePhrase(this.translationAlertText, lang);
  }

  public observeLangPushScreen(lang: string): Observable<Translation[]> {
    return this.observePhrases(this.langPushScreen, lang);
  }

  private observePhrase(phrase: string, lang: string): Observable<Translation> {
    if (!this.useTranslations) { return; }
    const strId = HackUtils.simpleBitHashHex(phrase);
    return this.fire.getTranslation(1, lang, strId).pipe(
      flatMap(translation => {
        if (translation != null) {
          return of(translation);
        } else {
          return this.lingua.translate([{phrase, str_id: strId, venue_id: 1}], lang).pipe(
            flatMap(res => {
              return this.fire.observeTranslation(1, lang, strId);
            }),
            filter(t => t != null),
            first()
          );
        }
      })
    );
  }

  private observePhrases(phrases: string[], lang: string): Observable<Translation[]> {
    if (!this.useTranslations) { return of([]); }

    // Create observables for each phrase
    const observables = phrases.map(phrase => this.observePhrase(phrase, lang));

    // Combine all observables and emit when all are complete
    return combineLatest(observables);
  }


  public prepareLangTranslation(code): Observable<boolean> {
    console.log("Prepare lang translation: ", code, this.venueId);
    this.prepapreTranslation(this.venueId, code);
    this.kickOffVenueConfigTranslations();
    for (const s of this.validSingleStrings) {
      this.translateString(s, false, true);
    }

    return combineLatest([
      this.fire.observeTranslations(1, code),
      interval(1000)]
    ).pipe(
      tap(([translations, n]) => console.log("Translation count: ", translations.length, this.validSingleStrings.length, "tobe: ", this.tobeTranslated.length)),
      map<[Translation[], number], boolean>(([translations, n]) => translations.length > this.validSingleStrings.length-4 && this.tobeTranslated.length < 1)
    );
  }

  private kickOffVenueConfigTranslations() {
    if (this.config.dt.inhouse) {
      this.translateString(this.config.dt.inhouse.title, false, false);
      this.translateString(this.config.dt.inhouse.desc, false, false);
    }
    if (this.config.dt.takeaway) {
      this.translateString(this.config.dt.takeaway.title, false, false);
      this.translateString(this.config.dt.takeaway.desc, false, false);
    }
    if (this.config.dt.roomservice) {
      this.translateString(this.config.dt.roomservice.title, false, false);
      this.translateString(this.config.dt.roomservice.desc, false, false);
    }
    if (this.config.dt.pickup) {
      this.translateString(this.config.dt.pickup.title, false, false);
      this.translateString(this.config.dt.pickup.desc, false, false);
    }
    if (this.config.dt.foodcourt) {
      this.translateString(this.config.dt.foodcourt.title, false, false);
      this.translateString(this.config.dt.foodcourt.desc, false, false);
    }
    if (this.config.review?.review_text) {
      this.translateString(this.config.review.review_text, false, false);
    }
  }

  isActive() {
    return this.lang !== "sv";
  }

  checkAndProcessUrlLanguage() {
    console.log('checkAndProcessUrlLanguage called early');

    // Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');

    if (urlLang) {
      console.log(`Found URL lang parameter: ${urlLang}`);

      // Validate the language code
      const validLangs = ['en', 'fr', 'de', 'es', 'it', 'zh', 'ja', 'ko', 'ar', 'tr', 'vi', 'nl', 'da', 'fi', 'no', 'is', 'he', 'hi', 'id', 'mr', 'tl', 'pl', 'sk', 'th', 'uk', 'pt', 'sv'];
      const lang = LangUtils.normalizeLang(urlLang);
      if (lang && validLangs.includes(lang)) {
        // Store the valid language
        this.urlLangOverride = lang;
        console.log(`TRL: Stored URL language override: ${this.urlLangOverride}`);
        console.log('TRL: Clearing flag from sessionStorage');
        localStorage.removeItem('hasShownLangPush2');

        // Clean the URL
        this.cleanUrlParams();
      } else {
        console.warn(`Invalid language code in URL: ${urlLang}`);
      }
    }
  }

  getBrowserLang() {
    // If we have a URL override, return it
    if (this.urlLangOverride) {
      console.log(`TRL: Returning URL language override: ${this.urlLangOverride}`);
      return this.urlLangOverride;
    }

    // Fall back to browser language
    const browserLang = navigator.language || navigator.languages?.[0] || 'sv';
    const primaryLang = LangUtils.normalizeLang(browserLang) || 'sv';
    console.log(`TRL: Browser language: ${browserLang}, returning: ${primaryLang}`);
    return primaryLang;
  }

  getString(s: string, pc="normal") {
    return this.single(s, pc);
  }

  translateItemComment(comment: string | undefined): string {
    if (!comment || this.lang === "sv") {
      return comment ?? "";
    }
    const parts = comment.split(/,\s*|\s+och\s+(?=utan\b)/i);
    const matches = parts.map(part => part.match(/^utan\s+(.+?)(?:\s+\((.+)\))?$/i));
    if (matches.some(match => match == null)) {
      return comment;
    }
    const translatedParts = matches.map(match => {
      const name = this.getString(match![1], "lower");
      const info = match![2] ? ` (${this.getString(match![2], "lower")})` : "";
      return `${this.getString("utan")} ${name}${info}`;
    });
    const conjunction = ` ${this.getString("och")} `;
    let translated = translatedParts.join(conjunction);
    if (translatedParts.length > 2) {
      translated = `${translatedParts.slice(0, -1).join(", ")}${conjunction}${translatedParts.at(-1)}`;
    }
    return translated.charAt(0).toUpperCase() + translated.slice(1);
  }

  cleanUrlParams() {
    // Remove lang parameter from URL without page reload
    const url = new URL(window.location.href);
    if (url.searchParams.has('lang')) {
      url.searchParams.delete('lang');
      window.history.replaceState({}, '', url.toString());
      console.log('Cleaned lang parameter from URL');
    }
  }

  private startBackgroundMenuTranslation(venueId: number) {
    if (this.backgroundTranslationInProgress || this.lang === "sv") {
      return;
    }

    // Lazy load MenuService to avoid circular dependency
    import('./menu.service').then(({MenuService}) => {
      const menuService = this.injector.get(MenuService);

      // Subscribe to menu changes
      this.menuSub = menuService.observeUnfilteredMenu(venueId.toString()).pipe(
        first() // Take only the first emission to avoid continuous re-translation
      ).subscribe(menu => {
        if (!menu) return;

        this.backgroundTranslationInProgress = true;
        console.log(`Starting background menu translation for ${this.lang}`);

        // Process menu in batches with delays to avoid overwhelming the API
        this.processMenuInBackground(menu);
      });
    });
  }

  private processMenuInBackground(menu: any) {
    try {
      // 1. First translate sections
      if (menu.food) {
        this.translateSectionsInBatches(menu.food);
      }
      if (menu.drinks) {
        this.translateSectionsInBatches(menu.drinks);
      }

      // 2. Then translate categories
      if (menu.food) {
        this.translateCategoriesInBatches(menu.food);
      }
      if (menu.drinks) {
        this.translateCategoriesInBatches(menu.drinks);
      }

      // 3. Finally translate items (only visible ones)
      if (menu.food) {
        this.translateItemsInBatches(menu.food);
      }
      if (menu.drinks) {
        this.translateItemsInBatches(menu.drinks);
      }

      console.log(`Background menu translation initiated for ${this.lang}`);
    } catch (error) {
      console.error('Error in background menu translation:', error);
    } finally {
      // Note: backgroundTranslationInProgress will be set to false when all translations are received
      setTimeout(() => {
        this.backgroundTranslationInProgress = false;
      }, 5000); // Give it 5 seconds for translations to complete
    }
  }

  private translateSectionsInBatches(sections: MenuSection[]) {
    const visibleSections = sections.filter(s => !s.mhide);
    this.sections(visibleSections);
  }

  private translateCategoriesInBatches(sections: MenuSection[]) {
    for (const section of sections) {
      if (section.mhide || !section.categories) continue;

      const visibleCategories = section.categories.filter(c => !c.mhide);
      this.categories(visibleCategories);
    }
  }

  private translateItemsInBatches(sections: MenuSection[]) {
    for (const section of sections) {
      if (section.mhide || !section.categories) continue;

      for (const category of section.categories) {
        if (category.mhide || !category.items) continue;

        const visibleItems = category.items.filter(item => !item.hidden && !item.mhide);
        this.items(visibleItems);
      }
    }
  }

  getTranslationsReceivedSubject() {
    return this.translationsReceivedSubject.asObservable();
  }

  // Public methods for translation progress tracking
  getTranslationProgress(): Observable<{inProgress: boolean, percentage: number}> {
    return this.translationProgressSubject.asObservable();
  }

  isTranslationComplete(): boolean {
    return !this.isTranslationInProgress;
  }
}
